import React from "react"
import "./broom.css"

function Broom() {
  return (
    <div className="broom-container">
      <div className="broom-handle"></div>
      <div className="broom-connector"></div>
      <div className="broom-head">
        <div className="broom-bristles"></div>
      </div>
    </div>
  )
}

export default Broom
